export default __webpack_public_path__ + "static/media/group_total_customer.94c4b46f.svg";